<template>
<div>
    <div class="container container-fluid">
        <h1 class="page-heading">Community Tabs</h1>
    </div>

    <!-- Dev Notes: This only simulates the PHD class on the body element in production, this is not part of the component -->
    <div class="PHD">
        <div class="l-main">

        <!-- CONTAINER - - - - - - - - - - - -->
        <div class="container container-fluid">
            <div class="l-phd l-phd--phd-community">
                <!-- SIMPLE TABS COMPONENT -->
                <div>
                    <!-- TABS WRAPPER -->
                    <div class="d-flex c-simple-tabs c-simple-tabs--border-top ">
                        <div class="col-sm-12">
                            <!-- TABS -->
                            <b-tabs vertical nav-wrapper-class="col-md-4 tabs__nav tabs__nav--phd-community" content-class="tab-content--phd-community" v-tabs-custom-tabbing>
                                <!-- TAB -->
                                <b-tab title="Journals" active>
                                    <!-- CONTENT -->
                                        <simple-accordion title="Journals" variant="phd-community">
                                            <h2 class="phd-h2 c-programming__heading">Related Journal Content</h2>

                                            <!-- PHD Article Link component (Other variations found below and here: Project\Heart-FrontEnd\demo\components\phd\phd-article-link.vue) -->
                                            <div class="PHD__article-link-container">
                                                <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                                <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                            </div>

                                            <div class="PHD__article-link-container">
                                                <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                                <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                            </div>

                                            <!-- News Link component with additional classes for the variant styles called for in this PHD Community Tabs component. -->
                                            <div class="news-link news-link--phd-community">
                                                <div class="container">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p><a href="#" class="c-cta c-cta--arrow">VIEW ALL Related Journals Content</a></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </simple-accordion>
                                    <!-- END CONTENT -->
                                </b-tab>

                                <!-- TAB -->
                                <b-tab title="Science News">
                                <!-- CONTENT -->
                                    <simple-accordion title="Science News" variant="phd-community">
                                        <h2 class="phd-h2 c-programming__heading">Related Science News</h2>

                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- News Link component with additional classes for the variant styles called for in this PHD Community Tabs component. -->
                                        <div class="news-link news-link--phd-community">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p><a href="#" class="c-cta c-cta--arrow">VIEW ALL Related Science News Content</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </simple-accordion>
                                <!-- END CONTENT -->
                                </b-tab>

                                <!-- TAB -->
                                <b-tab title="Guidelines &amp; Statements">
                                <!-- CONTENT -->
                                    <simple-accordion title="Guidelines &amp; Statements" variant="phd-community">
                                        <h2 class="phd-h2 c-programming__heading">Related Guidelines &amp; Statements</h2>

                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <!-- News Link component with additional classes for the variant styles called for in this PHD Community Tabs component. -->
                                        <div class="news-link news-link--phd-community">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p><a href="#" class="c-cta c-cta--arrow">VIEW ALL Related Guidelines &amp; Statements Content</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </simple-accordion>
                                <!-- END CONTENT -->
                                </b-tab>

                                <!-- TAB -->
                                <b-tab title="Meetings">
                                <!-- CONTENT -->
                                    <simple-accordion title="Meetings" variant="phd-community">
                                        <h2 class="phd-h2 c-programming__heading">Related Meetings</h2>

                                        <!-- Markup for this component (#88776) can be found at Project\Heart-FrontEnd\demo\components\phd\phd-meeting.vue -->
                                        <phd-meeting></phd-meeting>

                                        <phd-meeting></phd-meeting>

                                        <!-- News Link component with additional classes for the variant styles called for in this PHD Community Tabs component. -->
                                        <div class="news-link news-link--phd-community">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p><a href="#" class="c-cta c-cta--arrow">VIEW ALL Meetings</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </simple-accordion>
                                <!-- END CONTENT -->
                                </b-tab>

                                <!-- TAB -->
                                <b-tab title="Education">
                                <!-- CONTENT -->
                                    <simple-accordion title="Continuing Education" variant="phd-community">
                                        <h2 class="phd-h2 c-programming__heading">Continuing Education</h2>

                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link PHD__article-link--large">Cryptogenic Stroke: Evaluation and Management</a>
                                            <p class="PHD__article-summary">This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.</p>
                                        </div>

                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link PHD__article-link--large">Cryptogenic Stroke: Evaluation and Management</a>
                                            <p class="PHD__article-summary">This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.</p>
                                        </div>

                                        <!-- News Link component with additional classes for the variant styles called for in this PHD Community Tabs component. -->
                                        <div class="news-link news-link--phd-community">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p><a href="#" class="c-cta c-cta--arrow">VIEW MORE EDUCATION ON LIFE LONG LEARNING</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </simple-accordion>
                                <!-- END CONTENT -->
                                </b-tab>

                                <!-- TAB -->
                                <b-tab title="Council">
                                <!-- CONTENT -->
                                    <simple-accordion title="Scientific Councils" variant="phd-community">
                                        <h2 class="phd-h2 c-programming__heading">Related Scientific Councils</h2>

                                        <phd-card></phd-card>

                                        <phd-card></phd-card>

                                        <phd-card></phd-card>

                                        <phd-card></phd-card>

                                        <!-- News Link component with additional classes for the variant styles called for in this PHD Community Tabs component. -->
                                        <div class="news-link news-link--phd-community">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p><a href="#" class="c-cta c-cta--arrow">VIEW ALL Related Councils Content</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </simple-accordion>
                                <!-- END CONTENT -->
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                    <!-- END SIMPLE TABS -->
                </div>
            </div>
        </div>
        <!-- END CONTAINER - - - - - - - - - -->

        </div>
    </div> <!-- End div.PHD -->
</div>
</template>

<script>
  export default {
    data() {
      return {};
    }
  };
</script>



// WEBPACK FOOTER //
// demo/pages/layouts/phd-community-tabs.vue